import React, { Component } from 'react'
import { Route, Switch }    from 'react-router-dom'
import List                 from './List'
import Detail               from './Detail'
import Status404            from '../Status404'

class Major extends Component {

  render() {
    const { match } = this.props
    return (
      <Switch>
        <Route path={`${match.url}/list`} component={List}/>
        <Route path={`${match.url}/detail/:id`} component={Detail}/>
        <Route component={Status404}/>
      </Switch>
    )
  }
}

Major.propTypes = {}

export default Major



// WEBPACK FOOTER //
// ./src/pages/Major/index.js